import React from "react";
import officeBackgroundImage from "../../../assets/images/officeImage.png";
import style from "./index.scss";

const BackgroundLayout = () => {
  return (
    <div className={style["background-div"]}>
      <div className={style["site"]}>
        <div
          className={style["image-div"]}
          style={{ backgroundImage: `url(${officeBackgroundImage})` }}
        ></div>
      </div>
    </div>
  );
};
export default BackgroundLayout;
